import { IRoute } from "@lib/types/Routes";
import Error401 from "@app/ErrorPages/Error401";
import Error403 from "@app/ErrorPages/Error403";
import Error404 from "@app/ErrorPages/Error404";
import Error500 from "@app/ErrorPages/Error500";
import Error503 from "@app/ErrorPages/Error503";
import ComingSoon from "@app/ErrorPages/ComingSoon";
import Maintenance from "@app/ErrorPages/Maintenance";

export const errorPagesConfigs: IRoute[] = [
  {
    path: "/error-pages/error-401",
    element: <Error401 />,
  },
  {
    path: "/error-pages/error-403",
    element: <Error403 />,
  },
  {
    path: "/error-pages/error-404",
    element: <Error404 />,
  },
  {
    path: "/error-pages/error-500",
    element: <Error500 />,
  },
  {
    path: "/error-pages/error-503",
    element: <Error503 />,
  },
  {
    path: "/error-pages/coming-soon",
    element: <ComingSoon />,
  },
  {
    path: "/error-pages/maintenance",
    element: <Maintenance />,
  },
];
